import { authApiService } from '../../authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export const sendTwoFACodeApi = async (): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/users/auth/2fa/send-code/`;

  return authApiService.POST(uri, {});
};
